const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRfidCards(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M416 512H96c-29.419 0-53.333-23.936-53.333-53.333v-192c0-29.398 23.914-53.334 53.333-53.334h320c29.419 0 53.333 23.936 53.333 53.334v192C469.333 488.064 445.419 512 416 512ZM96 234.667c-17.643 0-32 14.357-32 32v192c0 17.642 14.357 32 32 32h320c17.643 0 32-14.358 32-32v-192c0-17.643-14.357-32-32-32H96Z",
    style: {
      fill: "#727272",
      fillRule: "nonzero"
    },
    transform: "translate(-2.4 -8.4) scale(.05625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.667 448H117.333c-5.888 0-10.666-4.779-10.666-10.667s4.778-10.666 10.666-10.666h277.334c5.888 0 10.666 4.778 10.666 10.666 0 5.888-4.778 10.667-10.666 10.667Z",
    style: {
      fill: "#727272",
      fillRule: "nonzero"
    },
    transform: "translate(-2.4 -8.4) scale(.05625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 85.333c-23.531 0-42.667-19.136-42.667-42.666C213.333 19.136 232.469 0 256 0c23.531 0 42.667 19.136 42.667 42.667 0 23.53-19.136 42.666-42.667 42.666Zm0-64c-11.776 0-21.333 9.579-21.333 21.334C234.667 54.421 244.224 64 256 64c11.776 0 21.333-9.579 21.333-21.333 0-11.755-9.557-21.334-21.333-21.334Z",
    style: {
      fill: "#727272",
      fillRule: "nonzero"
    },
    transform: "matrix(.0252 0 0 .02429 9.484 8.385)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 170.667c-5.888 0-10.667-4.779-10.667-10.667V74.667C245.333 68.779 250.112 64 256 64s10.667 4.779 10.667 10.667V160c0 5.888-4.779 10.667-10.667 10.667ZM128 170.667a10.716 10.716 0 0 1-7.552-3.115l-21.333-21.333A10.745 10.745 0 0 1 96 138.667v-64C96 68.779 100.779 64 106.667 64s10.666 4.779 10.666 10.667v59.584l18.219 18.218c4.16 4.16 4.16 10.923 0 15.083a10.716 10.716 0 0 1-7.552 3.115Z",
    style: {
      fill: "#727272",
      fillRule: "nonzero"
    },
    transform: "matrix(.0252 0 0 .02429 9.484 8.385)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.667 85.333C83.136 85.333 64 66.197 64 42.667 64 19.136 83.136 0 106.667 0c23.53 0 42.666 19.136 42.666 42.667 0 23.53-19.136 42.666-42.666 42.666Zm0-64c-11.776 0-21.334 9.579-21.334 21.334C85.333 54.421 94.891 64 106.667 64S128 54.421 128 42.667c0-11.755-9.557-21.334-21.333-21.334ZM384 170.667a10.716 10.716 0 0 1-7.552-3.115c-4.16-4.16-4.16-10.923 0-15.083l18.219-18.218V74.667c0-5.888 4.778-10.667 10.666-10.667C411.221 64 416 68.779 416 74.667v64c0 2.837-1.131 5.546-3.115 7.552l-21.333 21.333a10.716 10.716 0 0 1-7.552 3.115Z",
    style: {
      fill: "#727272",
      fillRule: "nonzero"
    },
    transform: "matrix(.0252 0 0 .02429 9.484 8.385)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.333 85.333c-23.53 0-42.666-19.136-42.666-42.666C362.667 19.136 381.803 0 405.333 0 428.864 0 448 19.136 448 42.667c0 23.53-19.136 42.666-42.667 42.666Zm0-64c-11.776 0-21.333 9.579-21.333 21.334C384 54.421 393.557 64 405.333 64c11.776 0 21.334-9.579 21.334-21.333 0-11.755-9.558-21.334-21.334-21.334Z",
    style: {
      fill: "#727272",
      fillRule: "nonzero"
    },
    transform: "matrix(.0252 0 0 .02429 9.484 8.385)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.915 0v437.804h433.974V0H1.915Zm410.928 414.758H158.308L94.974 351.43V93.13h316.829v259.872H199.601l-47.653-47.652V161.624h207.38V298.6h-95.093l-17.803-17.803h48.042v-80.656H213.83v80.656h.718l-.354.348 40.5 40.495h127.661V138.58H128.899v176.31l61.156 61.153h222.789v38.715h-.001Zm0-344.668H71.931v290.88l53.797 53.8H24.964V23.049h387.879V70.09Z",
    style: {
      fill: "#727272",
      fillRule: "nonzero"
    },
    transform: "matrix(.01494 0 0 .01494 3.526 7.216)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRfidCards);
export default __webpack_public_path__ + "static/media/ic-rfid-cards.e5d6b31e8bef715144a4c90b746b4893.svg";
export { ForwardRef as ReactComponent };